import React, { useState } from "react";
import { ConversationsBubbleType } from "../../../../libraries/types_interface/chats/ChatsTypes";
import { useDispatch } from "react-redux";
import { chatResfreshTimeStamp } from "../../../../libraries/state_reducers/chats/ChatsReducer";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";
import SessionStorage from "../../../../service/storage/SessionStorage";
import StorageKeys from "../../../../const/StorageKeys";
import { addModal } from "../../../../libraries/state_reducers/widget/ModalsReducer";
import ModalKeys from "../../../../const/ModalKeys";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import Center from "../../../../widget/common/ui/Center";
import Loader from "../../../../widget/common/ui/Loader";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import { Position } from "../../../../widget/common/ui/Stack";

const BubbleVideo: React.FC<ConversationsBubbleType> = ({
  message,
  videoSize = "",
  audioShowControl = false,
  longPressStatus = false,
}) => {
  const url: string = message.split("|")[1];
  const dispatch = useDispatch();
  const type: number = ResponsiveDeviceType();

  const [loaded, setLoaded] = useState<boolean>(false);

  const loadedCallBack = () => {
    console.log(`loadedCallBack`);
    setLoaded(true);
    dispatch(chatResfreshTimeStamp());
  };

  const handleClick = () => {
    if (!longPressStatus) {
      if (UtilityHelper.isNotEmpty(url)) {
        SessionStorage.saveValue(
          StorageKeys.preview_image_document,
          JSON.stringify({
            title: "",
            url: url,
          })
        );

        dispatch(
          addModal({
            id:
              type === 3
                ? ModalKeys.preview_image_document
                : ModalKeys.chat_preview_image_document,
            title: AppTranslation.text("preview"),
            screenMobileView: type === 3 ? false : true,
          })
        );
      }
    }
  };

  return (
    <div className="bubble-video position-relative">
      <div role="button" onClick={handleClick} className="bubble-video">
        <video
          width={UtilityHelper.isEmpty(videoSize) ? "200" : videoSize}
          height={UtilityHelper.isEmpty(videoSize) ? "inherit" : videoSize}
          controls={audioShowControl}
          autoPlay={false}
          loop={false}
          muted={false}
          playsInline
          onLoadedData={loadedCallBack}
        >
          <source src={url} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {!loaded && (
          <Position top={0} className="h-100 w-100">
            <Center className="h-100 w-100">{Loader.normal()}</Center>
          </Position>
        )}

        {!audioShowControl && loaded && (
          <div className="video-play-icon">
            <div className="icon-play">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                fill="currentColor"
                className="bi bi-play-fill"
                viewBox="0 0 16 16"
              >
                <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393" />
              </svg>
            </div>
          </div>
        )}

        {loaded && (
          <div className="video-duration font-gotham-book font-size-10_12 color-theme-bg">
            {message.split("|")[4]}
          </div>
        )}
      </div>
    </div>
  );
};

export default BubbleVideo;
